import * as React from "react";
import { graphql } from "react-apollo";
import gql from "graphql-tag";
import { Link } from "react-router-dom";

import DatePicker from "material-ui/DatePicker";

import handleMutationError from "app/utils/handleMutationError";

let OFFSET = 0;
let LIMIT = 10;

class Summary extends React.Component<any, any> {
  constructor(props: any) {
    super(props);
    this.state = {
      limit: LIMIT,
      settlement_batches: [],
      sbloading: false,
      sboffset: OFFSET,
      sbcreated_at_from: null,
      sbcreated_at_to: null,
      bank_settlements: [],
      bsloading: false,
      bsoffset: OFFSET,
      bscreated_at_from: null,
      bscreated_at_to: null
    };

    // FILTER
    this.filterFrom = this.filterFrom.bind(this);
    this.filterTo = this.filterTo.bind(this);

    // PAGINATION
    this.goNext = this.goNext.bind(this);
    this.goPrev = this.goPrev.bind(this);

    // DATA LOAD
    this.loadAllData = this.loadAllData.bind(this);
    this.loadBatches = this.loadBatches.bind(this);
    this.loadBankSettlements = this.loadBankSettlements.bind(this);

    // MUTATION
    this.submitSettlementBatch = this.submitSettlementBatch.bind(this);
  }

  componentDidMount() {
    this.loadAllData();
    this.props.setHeader({
      title: "Settlements",
      description: "SnapScan Settlements"
    });
  }

  submitSettlementBatch(id: any) {
    this.props
      .submit_settlement_batch({
        variables: {
          id: id
        }
      })
      .then(({ data }) => {
        this.loadBatches(undefined, undefined, undefined);
      })
      .catch(handleMutationError);
  }

  loadAllData() {
    this.loadBatches(
      this.state.sbcreated_at_from,
      this.state.sbcreated_at_to,
      OFFSET
    );
    this.loadBankSettlements(
      this.state.bscreated_at_from,
      this.state.bscreated_at_to,
      OFFSET
    );
  }
  loadBankSettlements(createdAtFrom: any, createdAtTo: any, offset: any) {
    this.setState({
      bank_settlements: [],
      bsloading: true,
      bsoffset: offset,
      bscreated_at_from: createdAtFrom,
      bscreated_at_to: createdAtTo
    });

    this.props.bank_settlements.fetchMore({
      variables: {
        created_at_from: createdAtFrom,
        created_at_to: createdAtTo,
        offset: offset
      },
      updateQuery: (previousResult, { fetchMoreResult }) => {
        this.setState({
          bank_settlements: [...fetchMoreResult.bank_settlements],
          bsloading: false
        });
      }
    });
  }
  loadBatches(createdAtFrom: any, createdAtTo: any, offset: any) {
    this.setState({
      settlement_batches: [],
      sbloading: true,
      sboffset: offset,
      sbcreated_at_from: createdAtFrom,
      sbcreated_at_to: createdAtTo
    });

    this.props.settlement_batches.fetchMore({
      variables: {
        created_at_from: createdAtFrom,
        created_at_to: createdAtTo,
        offset: offset
      },
      updateQuery: (previousResult, { fetchMoreResult }) => {
        this.setState({
          settlement_batches: [...fetchMoreResult.settlement_batches],
          sbloading: false
        });
      }
    });
  }

  goNext(table: any) {
    if (table === "settlement_batches") {
      const TMP_OFFSET =
        parseInt(this.state.sboffset, 10) + parseInt(this.state.limit, 10);
      this.loadBatches(
        this.state.sbcreated_at_from,
        this.state.sbcreated_at_to,
        TMP_OFFSET
      );
    } else if (table === "bank_settlements") {
      const TMP_OFFSET =
        parseInt(this.state.bsoffset, 10) + parseInt(this.state.limit, 10);
      this.loadBankSettlements(
        this.state.bscreated_at_from,
        this.state.bscreated_at_to,
        TMP_OFFSET
      );
    }
  }
  goPrev(table: any) {
    if (table === "settlement_batches") {
      const TMP_OFFSET =
        parseInt(this.state.sboffset, 10) - parseInt(this.state.limit, 10);
      this.loadBatches(
        this.state.sbcreated_at_from,
        this.state.sbcreated_at_to,
        TMP_OFFSET
      );
    } else if (table === "bank_settlements") {
      const TMP_OFFSET =
        parseInt(this.state.bsoffset, 10) - parseInt(this.state.limit, 10);
      this.loadBankSettlements(
        this.state.bscreated_at_from,
        this.state.bscreated_at_to,
        TMP_OFFSET
      );
    }
  }

  filterFrom(event: any, date: any, table: any) {
    if (table === "settlement_batches") {
      this.loadBatches(this.state.bscreated_at_from, date, 0);
    } else if (table === "bank_settlements") {
      this.loadBankSettlements(this.state.bscreated_at_from, date, 0);
    }
  }
  filterTo(event: any, date: any, table: any) {
    if (table === "settlement_batches") {
      this.loadBatches(this.state.bscreated_at_from, date, 0);
    } else if (table === "bank_settlements") {
      this.loadBankSettlements(this.state.bscreated_at_from, date, 0);
    }
  }

  render() {
    let bankSettlementsList =
      this.state.bank_settlements && this.state.bank_settlements.length > 0
        ? this.state.bank_settlements
        : [];
    let batchesList =
      this.state.settlement_batches && this.state.settlement_batches.length > 0
        ? this.state.settlement_batches
        : [];

    const statusButton = (status, id) => {
      if (status === "pending") {
        return (
          <button
            className="button statusButton"
            style={{
              zoom: 0.7,
              marginRight: "10px",
              position: "absolute",
              right: "10px",
              top: "10px"
            }}
            onClick={() => this.submitSettlementBatch(id)}
          >
            Submit
          </button>
        );
      } else {
        return null;
      }
    };

    return (
      <section id="Ops_PaymentsList" className="padded">
        <span>
          <h3
            style={{
              borderBottom: "1px solid rgb(204, 204, 204)",
              fontWeight: 400,
              display: "flex",
              alignItems: "center",
              marginTop: 0
            }}
          >
            <span style={{ marginRight: "10px" }}>
              Pending Settlement Batches:{" "}
            </span>
            <div
              style={{
                display: "flex",
                justifyContent: "flex-start"
              }}
            >
              <DatePicker
                hintText="From"
                onChange={(event, date, table) =>
                  this.filterFrom(event, date, "settlement_batches")
                }
                style={{
                  width: "200px",
                  marginRight: "10px"
                }}
                textFieldStyle={{
                  width: "200px"
                }}
              />
              <DatePicker
                hintText="To"
                onChange={(event, date, table) =>
                  this.filterTo(event, date, "settlement_batches")
                }
                style={{
                  width: "200px",
                  marginRight: "10px"
                }}
                textFieldStyle={{
                  width: "200px"
                }}
              />
            </div>
          </h3>
          <div
            id="setHeight"
            style={{
              height: "calc(50% - 100px)",
              overflow: "auto"
            }}
          >
            <table
              style={{
                width: "100%"
              }}
              className={`BOTable`}
              cellPadding={0}
              cellSpacing={0}
            >
              <thead>
                <tr>
                  <th>Date</th>
                  <th>ID</th>
                  <th>Status</th>
                  <th>Comment</th>
                </tr>
              </thead>
              <tbody className={`${this.state.sbloading ? "hidden" : "shown"}`}>
                {batchesList.map((val, key) => {
                  return (
                    <tr key={key}>
                      <td>{val.created_at}</td>
                      <td>
                        <Link
                          className="blueLink"
                          to={`/snapscan/settlements/batches/${val.id}/summary`}
                        >
                          {val.id}
                        </Link>
                      </td>
                      <td>{val.status}</td>
                      <td style={{ position: "relative" }}>
                        {val.comment}
                        {statusButton(val.status, val.id)}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
          <button
            className={
              this.state.sboffset === 0 || this.state.sbloading ? "hidden" : ""
            }
            style={{ margin: "5px", padding: "4px" }}
            onClick={() => this.goPrev("settlement_batches")}
          >
            <i className="fa fa-chevron-left" />
          </button>
          <button
            className={
              batchesList.length < LIMIT || this.state.sbloading ? "hidden" : ""
            }
            style={{ margin: "5px", padding: "4px" }}
            onClick={() => this.goNext("settlement_batches")}
          >
            <i className="fa fa-chevron-right" />
          </button>
        </span>
        <hr
          style={{
            border: 0,
            marginTop: "10px"
          }}
        />
        <span>
          <h3
            style={{
              borderBottom: "1px solid rgb(204, 204, 204)",
              fontWeight: 400,
              display: "flex",
              alignItems: "center",
              marginTop: 0
            }}
          >
            <span style={{ marginRight: "10px" }}>
              Withheld Bank Settlements:{" "}
            </span>
            <div
              style={{
                display: "flex",
                justifyContent: "flex-start"
              }}
            >
              <DatePicker
                hintText="From"
                onChange={(event, date, table) =>
                  this.filterFrom(event, date, "bank_settlements")
                }
                style={{
                  width: "200px",
                  marginRight: "10px"
                }}
                textFieldStyle={{
                  width: "200px"
                }}
              />
              <DatePicker
                hintText="To"
                onChange={(event, date, table) =>
                  this.filterTo(event, date, "bank_settlements")
                }
                style={{
                  width: "200px",
                  marginRight: "10px"
                }}
                textFieldStyle={{
                  width: "200px"
                }}
              />
            </div>
          </h3>
          <div
            id="setHeight"
            style={{
              height: "calc(50% - 100px)",
              overflow: "auto"
            }}
          >
            <table
              style={{
                width: "100%"
              }}
              className={`BOTable`}
              cellPadding={0}
              cellSpacing={0}
            >
              <thead>
                <tr>
                  <th>Date</th>
                  <th>ID</th>
                  <th>Status</th>
                  <th>Bank</th>
                  <th>Merchant</th>
                </tr>
              </thead>
              <tbody className={`${this.state.bsloading ? "hidden" : "shown"}`}>
                {bankSettlementsList.map((val, key) => {
                  return (
                    <tr key={key}>
                      <td>{val.created_at}</td>
                      <td>
                        <Link
                          className="blueLink"
                          to={`/snapscan/settlements/bank_settlements/${val.id}/summary`}
                        >
                          {val.id}
                        </Link>
                      </td>
                      <td>{val.status}</td>
                      <td>{val.bank_name}</td>
                      <td>
                        <Link
                          className="blueLink"
                          to={`/snapscan/ops/merchants/${val.merchant.id}/payments`}
                        >
                          {" "}
                          {val.merchant.name}{" "}
                        </Link>
                        <a
                          style={{ marginLeft: "6px" }}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="blueLink"
                          href={val.merchant.snapmin_url}
                        >
                          <i className="fa fa-info-circle" />
                        </a>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
          <button
            className={
              this.state.bsoffset === 0 || this.state.bsloading ? "hidden" : ""
            }
            style={{ margin: "5px", padding: "4px" }}
            onClick={() => this.goPrev("bank_settlements")}
          >
            <i className="fa fa-chevron-left" />
          </button>
          <button
            className={
              bankSettlementsList.length < LIMIT || this.state.bsloading
                ? "hidden"
                : ""
            }
            style={{ margin: "5px", padding: "4px" }}
            onClick={() => this.goNext("bank_settlements")}
          >
            <i className="fa fa-chevron-right" />
          </button>
        </span>
      </section>
    );
  }
}

// QUERIES
const SettlementBatches = graphql(
  gql`
    query SettlementBatches(
      $offset: Int
      $limit: Int
      $created_at_from: String
      $created_at_to: String
    ) {
      settlement_batches(
        offset: $offset
        limit: $limit
        created_at_from: $created_at_from
        created_at_to: $created_at_to
        status: pending
      ) {
        created_at
        id
        status
        comment
      }
    }
  `,
  {
    name: "settlement_batches",
    options(props: any) {
      return {
        variables: {
          created_at_from: null,
          created_at_to: null,
          offset: OFFSET,
          limit: LIMIT
        }
      };
    }
  }
);
const BankSettlements = graphql(
  gql`
    query BankSettlements(
      $offset: Int
      $limit: Int
      $created_at_from: String
      $created_at_to: String
    ) {
      bank_settlements(
        offset: $offset
        limit: $limit
        created_at_from: $created_at_from
        created_at_to: $created_at_to
        status: withheld
      ) {
        created_at
        id
        bank_name
        status
        merchant {
          name
          id
          snapmin_url
        }
      }
    }
  `,
  {
    name: "bank_settlements",
    options(props: any) {
      return {
        variables: {
          created_at_from: null,
          created_at_to: null,
          offset: OFFSET,
          limit: LIMIT
        }
      };
    }
  }
);
const releaseSettlement = graphql(
  gql`
    mutation releaseSettlement($id: ID!) {
      submit_settlement_batch(id: $id) {
        created_at
        id
      }
    }
  `,
  {
    name: "submit_settlement_batch"
  }
);

export default SettlementBatches(BankSettlements(releaseSettlement(Summary)));
